module.exports = __webpack_public_path__ + "img/boiler-plant-lg.c26b4984.svg";